(function () {
  var assemblySteps = [
    "Retira cuidadosamente todos los elementos del embalaje.",
    "Inserta o posiciona el tronco correctamente en el macetero o base.",
    "Abre las ramas desde el centro hacia afuera.",
    "Moldea las hojas una por una con suavidad.",
    "Observa la planta desde distintos ángulos y realiza pequeños ajustes hasta lograr una forma natural.",
    "Ubícala en su espacio final y revisa que la composición se vea equilibrada."
  ];

  var baseModelingTips = [
    "Dedica unos minutos a abrir cada hoja.",
    "La forma final depende del modelado.",
    "Si una hoja llega doblada, corrígela suavemente con las manos.",
    "Observa la planta desde distintos ángulos.",
    "Ajusta ramas y hojas hasta lograr una composiciÃ³n equilibrada."
  ];

  var careTips = [
    ["light", "Luz", "Evita la exposición prolongada al sol directo."],
    ["interior", "Interior", "Ideal para ambientes interiores."],
    ["clean", "Limpieza", "Limpia las hojas con un paño de microfibra ligeramente húmedo."],
    ["water", "Agua", "No requiere riego."],
    ["planter", "Macetero", "Puedes reemplazar el macetero para adaptarlo a tu decoración."]
  ];

  var icons = {
    interior: '<svg class="aura-pp-icon" viewBox="0 0 48 48" fill="none" aria-hidden="true"><path d="M8 40V18L24 7l16 11v22" stroke="currentColor" stroke-width="1.4"/><path d="M18 40V27h12v13M14 22h20" stroke="currentColor" stroke-width="1.4"/></svg>',
    light: '<svg class="aura-pp-icon" viewBox="0 0 48 48" fill="none" aria-hidden="true"><circle cx="24" cy="24" r="8" stroke="currentColor" stroke-width="1.4"/><path d="M24 5v7M24 36v7M5 24h7M36 24h7M10.5 10.5l5 5M32.5 32.5l5 5M37.5 10.5l-5 5M15.5 32.5l-5 5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
    clean: '<svg class="aura-pp-icon" viewBox="0 0 48 48" fill="none" aria-hidden="true"><path d="M17 29c7-3 11-8 13-16l6 6c-8 2-13 6-16 13l-3-3Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M12 35c5 4 12 4 17 0M10 40h26" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
    water: '<svg class="aura-pp-icon" viewBox="0 0 48 48" fill="none" aria-hidden="true"><path d="M24 7s11 13 11 22a11 11 0 0 1-22 0C13 20 24 7 24 7Z" stroke="currentColor" stroke-width="1.4"/><path d="M14 10l20 28" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
    planter: '<svg class="aura-pp-icon" viewBox="0 0 48 48" fill="none" aria-hidden="true"><path d="M14 21h20l-3 19H17l-3-19Z" stroke="currentColor" stroke-width="1.4"/><path d="M19 21c-1-8 3-12 10-13 1 7-2 12-10 13ZM24 21c3-6 8-8 14-6-2 6-6 9-14 6Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>'
  };

  function placeholderSvg(label) {
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="1500" viewBox="0 0 1200 1500" role="img" aria-label="' +
      label +
      '">' +
      '<rect width="1200" height="1500" fill="#f7f2e9"/><rect x="108" y="108" width="984" height="1284" fill="none" stroke="#0D2418" stroke-opacity=".16"/>' +
      '<path d="M600 1110 C520 1000 475 860 500 690 C530 470 665 320 780 245 C760 390 720 525 645 640 C720 610 805 610 905 665 C795 750 700 795 610 800 C625 925 640 1020 600 1110Z" fill="#0D2418" fill-opacity=".22"/>' +
      '<text x="600" y="1268" fill="#0D2418" fill-opacity=".76" font-family="Inter, Arial, sans-serif" font-size="34" text-anchor="middle">' +
      label +
      '</text><text x="600" y="1322" fill="#0D2418" fill-opacity=".52" font-family="Inter, Arial, sans-serif" font-size="20" text-anchor="middle">Subir imagen hero</text></svg>';

    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
  }

  function cleanItems(items) {
    return (items || []).map(function (item) {
      return String(item || "").trim();
    }).filter(Boolean);
  }

  function setText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) node.textContent = value;
  }

  function initSection(root, force) {
    var sectionId = root.getAttribute("data-section-id");
    var dataNode = document.getElementById("AuraPostPurchaseData-" + sectionId);
    if (!dataNode) return;

    var dataSignature = dataNode.textContent.length + ":" + dataNode.textContent.slice(0, 120);
    if (!force && root.dataset.auraDataSignature === dataSignature) return;
    root.dataset.auraDataSignature = dataSignature;

    var data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    var params = new URLSearchParams(window.location.search);
    var requestedProduct = (params.get("producto") || data.defaults.product || "").toLowerCase();
    var selectedBlock = params.get("block") || "";
    var productsList = Object.values(data.products);
    var editorProduct = productsList.find(function (candidate) {
      return candidate.blockId && selectedBlock.indexOf(candidate.blockId) !== -1;
    });
    var product = editorProduct || data.products[requestedProduct] || data.products[data.defaults.product] || productsList[0];
    if (!product) return;

    var productName = product.name || "planta";

    setText(root, "[data-aura-product-kicker]", productName + " Aura Verde");
    setText(root, "[data-aura-product-name]", productName);
    setText(root, "[data-aura-product-height]", "");
    setText(root, "[data-aura-video-duration]", data.defaults.videoDuration || "0:32");
    setText(root, "[data-aura-video-note]", "Video guÃ­a para armado de " + productName + ".");

    var heroImage = root.querySelector("[data-aura-hero-image]");
    if (heroImage) {
      heroImage.src = product.heroImage || placeholderSvg(productName);
      heroImage.alt = product.heroAlt || "Planta " + productName + " Aura Verde instalada en un ambiente premium";
    }

    var heroCaption = root.querySelector("[data-aura-hero-caption]");
    if (heroCaption) {
      heroCaption.textContent = product.heroImage ? productName + " Aura Verde" : "Subir imagen hero";
    }

    var videoLink = root.querySelector("[data-aura-video-link]");
    if (videoLink) {
      if (product.videoUrl) {
        videoLink.href = product.videoUrl;
      } else {
        videoLink.removeAttribute("href");
        videoLink.setAttribute("aria-disabled", "true");
      }
    }

    var stepsMount = root.querySelector("[data-aura-assembly-steps]");
    if (stepsMount) {
      stepsMount.innerHTML =
        '<div class="aura-pp-assembly-media">' +
        '<div class="aura-pp-assembly-counter" data-aura-assembly-counter>Paso 1 de ' + assemblySteps.length + '</div>' +
        '<button class="aura-pp-assembly-arrow aura-pp-assembly-arrow--prev" type="button" aria-label="Ver paso anterior">←</button>' +
        '<div class="aura-pp-assembly-track">' +
        assemblySteps.map(function (step, index) {
          var image = product.assemblyImages && product.assemblyImages[index];
          var media = image
            ? '<img src="' + image + '" alt="Paso ' + (index + 1) + ' de armado para ' + productName + '" loading="lazy" width="900" height="900" draggable="false">'
            : '<span class="aura-pp-placeholder-label">Subir foto paso ' + (index + 1) + '</span>';

          return '<article class="aura-pp-step-card" data-aura-assembly-slide="' + index + '"><div class="aura-pp-step-card__image">' + media + '</div></article>';
        }).join("") +
        '</div>' +
        '<button class="aura-pp-assembly-arrow aura-pp-assembly-arrow--next" type="button" aria-label="Ver paso siguiente">→</button>' +
        '</div>' +
        '<p class="aura-pp-assembly-caption" data-aura-assembly-caption></p>' +
        '<div class="aura-pp-assembly-controls">' +
        '<div class="aura-pp-assembly-dots" data-aura-assembly-dots>' +
        assemblySteps.map(function (_, index) {
          return '<button type="button" aria-label="Ver paso ' + (index + 1) + '" data-aura-assembly-dot="' + index + '"></button>';
        }).join("") +
        '</div></div>' +
        '<div class="aura-pp-assembly-divider" aria-hidden="true"></div>' +
        '<aside class="aura-pp-assembly-tip"><span aria-hidden="true"></span><div><p>El resultado final dependerá del modelado de sus hojas. Ábrelas suavemente, una a una, hasta conseguir una forma natural.</p></div></aside>';

      var activeStep = 0;
      var slides = Array.prototype.slice.call(stepsMount.querySelectorAll("[data-aura-assembly-slide]"));
      var dots = Array.prototype.slice.call(stepsMount.querySelectorAll("[data-aura-assembly-dot]"));
      var counter = stepsMount.querySelector("[data-aura-assembly-counter]");
      var caption = stepsMount.querySelector("[data-aura-assembly-caption]");
      var prev = stepsMount.querySelector(".aura-pp-assembly-arrow--prev");
      var next = stepsMount.querySelector(".aura-pp-assembly-arrow--next");

      var renderAssemblyStep = function () {
        slides.forEach(function (slide, index) {
          slide.classList.toggle("is-active", index === activeStep);
        });
        dots.forEach(function (dot, index) {
          dot.classList.toggle("is-active", index === activeStep);
          dot.setAttribute("aria-current", index === activeStep ? "step" : "false");
        });
        if (counter) counter.textContent = "Paso " + (activeStep + 1) + " de " + assemblySteps.length;
        if (caption) {
          caption.innerHTML =
            '<span class="aura-pp-assembly-caption__number" aria-hidden="true">' + (activeStep + 1) + '</span>' +
            '<span>' + assemblySteps[activeStep] + '</span>';
        }
      };

      var goToStep = function (index) {
        activeStep = (index + assemblySteps.length) % assemblySteps.length;
        renderAssemblyStep();
      };

      if (prev) prev.addEventListener("click", function () { goToStep(activeStep - 1); });
      if (next) next.addEventListener("click", function () { goToStep(activeStep + 1); });
      dots.forEach(function (dot, index) {
        dot.addEventListener("click", function () { goToStep(index); });
      });

      var touchStartX = 0;
      var touchStartY = 0;
      var track = stepsMount.querySelector(".aura-pp-assembly-track");
      var handleSwipe = function (startX, startY, endX, endY) {
        var deltaX = endX - startX;
        var deltaY = endY - startY;
        if (Math.abs(deltaX) < 28 || Math.abs(deltaX) < Math.abs(deltaY) * 1.15) return;
        goToStep(activeStep + (deltaX < 0 ? 1 : -1));
      };

      if (track) {
        track.addEventListener("touchstart", function (event) {
          if (!event.touches || !event.touches.length) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        }, { passive: true });

        track.addEventListener("touchend", function (event) {
          if (!event.changedTouches || !event.changedTouches.length) return;
          handleSwipe(touchStartX, touchStartY, event.changedTouches[0].clientX, event.changedTouches[0].clientY);
        }, { passive: true });
      }

      renderAssemblyStep();
    }

    var modelMount = root.querySelector("[data-aura-modeling-tips]");
    if (modelMount) {
      modelMount.innerHTML = baseModelingTips.concat(cleanItems(product.modelingTips)).map(function (tip) {
        return "<li>" + tip + "</li>";
      }).join("");
    }

    var careMount = root.querySelector("[data-aura-care-tips]");
    if (careMount) {
      var extraTips = cleanItems(product.careExtra).map(function (tip) {
        return ["interior", "Consejo Aura", tip];
      });

      careMount.innerHTML = careTips.concat(extraTips).map(function (tip) {
        return '<article class="aura-pp-care-card">' + icons[tip[0]] + "<div><h3>" + tip[1] + "</h3><p>" + tip[2] + "</p></div></article>";
      }).join("");

      careMount.insertAdjacentHTML(
        "beforeend",
        '<button class="aura-pp-care-arrow aura-pp-care-arrow--prev" type="button" aria-label="Ver cuidado anterior">â†</button>' +
          '<button class="aura-pp-care-arrow aura-pp-care-arrow--next" type="button" aria-label="Ver cuidado siguiente">â†’</button>'
      );

      var careCards = Array.prototype.slice.call(careMount.querySelectorAll(".aura-pp-care-card"));
      var careIndex = 0;
      var carePrev = careMount.querySelector(".aura-pp-care-arrow--prev");
      var careNext = careMount.querySelector(".aura-pp-care-arrow--next");

      var renderCare = function () {
        var mobileList = window.matchMedia && window.matchMedia("(max-width: 719px)").matches;
        careCards.forEach(function (card, index) {
          if (mobileList) {
            card.classList.add("is-mobile-visible");
            card.classList.remove("is-mobile-first");
            return;
          }
          var visible = index === careIndex || index === (careIndex + 1) % careCards.length;
          card.classList.toggle("is-mobile-visible", visible);
          card.classList.toggle("is-mobile-first", index === careIndex);
        });
      };

      var moveCare = function (direction) {
        careIndex = (careIndex + direction + careCards.length) % careCards.length;
        renderCare();
      };

      if (carePrev) carePrev.addEventListener("click", function () { moveCare(-1); });
      if (careNext) careNext.addEventListener("click", function () { moveCare(1); });
      renderCare();
    }

    var inspirationMount = root.querySelector("[data-aura-inspiration-cards]");
    if (inspirationMount) {
      var inspirationItems = product.inspiration || [];
      if (inspirationItems.length < 2) {
        inspirationItems = inspirationItems.concat([
          { title: "Living", copy: "Una pieza protagonista capaz de aportar altura, textura y equilibrio al espacio.", image: null, link: "#" },
          { title: "Hall de entrada", copy: "El primer detalle que recibe a quienes llegan a tu hogar.", image: null, link: "#" }
        ]).slice(0, 2);
      }

      inspirationMount.innerHTML = inspirationItems.filter(function (item) {
        return item.title || item.copy || item.image;
      }).map(function (item, index) {
        var fallbackTitle = index === 0 ? "Living" : "Hall de entrada";
        var title = item.title || fallbackTitle;
        var copy = item.copy || "";
        var style = item.image ? ' style="background-image: linear-gradient(180deg, rgba(13, 36, 24, .06), rgba(13, 36, 24, .62)), url(&quot;' + item.image + '&quot;)"' : "";
        var placeholder = item.image ? "" : '<span class="aura-pp-image-placeholder">Subir imagen ambiente</span>';

        return (
          '<article class="aura-pp-inspiration-card"><div class="aura-pp-inspiration-card__image"' +
          style +
          ">" +
          placeholder +
          '</div><div class="aura-pp-inspiration-card__content"><h3>' +
          title +
          "</h3><p>" +
          copy +
          "</p></div></article>"
        );
      }).join("");
    }

    var crossSellMount = root.querySelector("[data-aura-cross-sell]");
    if (crossSellMount) {
      crossSellMount.innerHTML = "";
    }

    var inspirationSetsMount = root.querySelector("[data-aura-inspiration-sets]");
    if (inspirationSetsMount) {
      var inspirationSets = Array.prototype.slice.call(inspirationSetsMount.querySelectorAll("[data-aura-inspiration-set]"));
      var activeInspirationSet = inspirationSets.find(function (set) {
        return set.getAttribute("data-aura-block-id") === product.blockId;
      }) || inspirationSets.find(function (set) {
        return set.getAttribute("data-aura-inspiration-set") === requestedProduct;
      }) || inspirationSets[0];

      inspirationSets.forEach(function (set) {
        if (set === activeInspirationSet) {
          set.removeAttribute("hidden");
        } else {
          set.setAttribute("hidden", "");
        }
      });
    }

    var revealItems = root.querySelectorAll(".aura-pp-reveal");
    var progressLinks = Array.prototype.slice.call(root.querySelectorAll('.aura-pp-progress a[href^="#"]'));
    var setActiveProgress = function (hash) {
      progressLinks.forEach(function (link) {
        var isActive = link.getAttribute("href") === hash;
        var item = link.closest("li");
        if (item) item.classList.toggle("is-active", isActive);
        link.setAttribute("aria-current", isActive ? "step" : "false");
      });
    };

    setActiveProgress("#AuraHero-" + sectionId);

    progressLinks.forEach(function (link) {
      link.addEventListener("click", function (event) {
        var hash = link.getAttribute("href");
        var target = root.querySelector(hash);
        if (!target) return;
        event.preventDefault();
        setActiveProgress(hash);
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    if ("IntersectionObserver" in window) {
      root.classList.add("aura-pp-motion-ready");
      var progressObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setActiveProgress("#" + entry.target.id);
          }
        });
      }, { rootMargin: "-35% 0px -55% 0px", threshold: 0.01 });

      ["AuraHero-", "AuraAssembly-", "AuraCare-", "AuraInspiration-", "AuraCommunity-"].forEach(function (prefix) {
        var section = root.querySelector("#" + prefix + sectionId);
        if (section) progressObserver.observe(section);
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16 });

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    } else {
      revealItems.forEach(function (item) {
        item.classList.add("is-visible");
      });
    }
  }

  function initAll() {
    document.querySelectorAll("[data-aura-post-purchase]").forEach(function (section) {
      initSection(section, false);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-aura-post-purchase]");
    if (section) initSection(section, true);
  });

  document.addEventListener("shopify:section:select", function (event) {
    var section = event.target.querySelector("[data-aura-post-purchase]");
    if (section) initSection(section, true);
  });

  document.addEventListener("shopify:block:select", function () {
    initAll();
  });
})();
